module.exports = __webpack_public_path__ + "static/img/cd_yl_disabled.fac39c60.png";